import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import arrify from 'arrify'
import { Popover, Position } from 'evergreen-ui'
import GroupedSelectMenuContent from './GroupedSelectMenuContent'
import OptionGroupShapePropType from './OptionGroupShapePropType'
import SelectedPropType from './SelectedPropType'
import { values } from 'lodash'

export default class GroupedSelectMenu extends PureComponent {
  static propTypes = {
    /**
     * The title of the Select Menu.
     */
    title: PropTypes.string,

    /**
     * The width of the Select Menu.
     */
    width: PropTypes.number,

    /**
     * The height of the Select Menu.
     */
    height: PropTypes.number,

    /**
     * The options to show in the menu.
     * [{ label: String, value: String | Number, labelInList?: String }]
     */
    options: PropTypes.arrayOf(OptionGroupShapePropType),

    /**
     * Function that is called when an option is selected.
     */
    onSelect: PropTypes.func,

    /**
     * If present, function that is called when an option is deselected.
     */
    onDeselect: PropTypes.func,

    /**
     *
     */
    selected: SelectedPropType,

    /**
     * When true, show the title.
     */
    hasTitle: PropTypes.bool,

    /**
     * When true, displays count of selected options in blue
     */
    hasCount: PropTypes.bool,

    /**
     * When true, show the filter.
     */
    hasFilter: PropTypes.bool,

    /**
     * The position of the Select Menu.
     */
    position: PropTypes.oneOf(values(Position)),

    /**
     * Empty view if no options are found.
     */
    emptyView: PropTypes.func,

    /**
     * Can be a function that returns a node, or a node itself, that is
     * rendered on the right side of the Select Menu to give additional
     * information when an option is selected.
     */
    detailView: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

    /**
     * Can be a function that returns a node that is rendered in place of the GroupedSelectMenu header
     */
    titleView: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

    /**
     * Function that is called as the onChange() event for the filter.
     */
    onFilterChange: PropTypes.func
  }

  static defaultProps = {
    onSelect: () => {},
    onDeselect: () => {},
    width: 240,
    height: 300,
    position: Position.BOTTOM_LEFT
  }

  getDetailView = (close, detailView) => {
    if (typeof detailView === 'function') {
      return {
        detailView: detailView({ close })
      }
    }

    if (detailView) {
      return { detailView }
    }

    return {}
  }

  render() {
    const {
      title,
      width,
      height,
      options,
      selected,
      position,
      hasTitle,
      hasFilter,
      hasCount,
      detailView,
      emptyView,
      titleView,
      ...props
    } = this.props
    const multiselect = Array.isArray(selected)

    return (
      <Popover
        minWidth={width}
        position={position}
        minHeight={height}
        content={({ close }) => (
          <GroupedSelectMenuContent
            width={width}
            height={height}
            groups={options}
            title={title}
            hasFilter={hasFilter}
            hasTitle={hasTitle}
            hasCount={hasCount}
            selected={arrify(selected)}
            emptyView={emptyView}
            titleView={titleView}
            listProps={{
              onSelect: item => {
                this.props.onSelect(item)
              },
              onDeselect: item => {
                this.props.onDeselect(item)
              },
              selected: arrify(selected),
              onFilterChange: this.props.onFilterChange
            }}
            close={close}
            multiselect={multiselect}
            {...this.getDetailView(close, detailView)}
          />
        )}
        {...props}
      />
    )
  }
}
